import { RouteRecordRaw } from "vue-router";

export const prescriptionRoutes: RouteRecordRaw[] = [
  {
    path: "/prescriptions/:id/edit",
    name: "PrescriptionEdit",
    component: () => import("../views/PrescriptionEdit.vue"),
    meta: {
      requiresAuth: true,
      requiredModule: "prescription",
      requiredRight: "viewUI",
    },
  },
];
